import { Controller } from "@hotwired/stimulus"

// range スライダーの現在値を、隣接する output 要素にライブ表示する。
// debounce 付きの再計算 (form-submit controller) とは独立に、ドラッグ中も即座に値を反映する。
export default class extends Controller {
  static targets = ["input", "output"]

  connect() {
    this.show()
  }

  show() {
    if (this.hasInputTarget && this.hasOutputTarget) {
      this.outputTarget.textContent = this.inputTarget.value
    }
  }
}
